
/** 主题类型 */
export enum ThemeType {
  WHITE = 'white',
  BLACK = 'black'
}
/** 主题存储key */
export const THEME_KEY = 'gitcode_theme';
